let cached: boolean | null = null;

/**
 * Instagram/Facebook in-app webviews (and some corporate Chrome policies) ship
 * with WebGL disabled; `new THREE.WebGLRenderer()` then throws "Error creating
 * WebGL context" and takes the whole route down. Probe once per page with a
 * throwaway canvas so the section can render a static fallback instead.
 */
export function isWebGLAvailable(): boolean {
  if (cached !== null) return cached;
  if (typeof document === 'undefined') return false;
  try {
    const canvas = document.createElement('canvas');
    cached = Boolean(canvas.getContext('webgl2') ?? canvas.getContext('webgl'));
  } catch {
    cached = false;
  }
  return cached;
}
